import React, { PropsWithChildren } from 'react';

export enum EChipType {
  Action = 'Action',
  Chip = 'Chip',
}

export type TChipsData = PropsWithChildren<{
  variant: EChipType;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}>;
